/*
 *
 * Report reducer
 *
 */
import { fromJS } from 'immutable'
import {
  CREATE_REPORT_SELECTION_ERROR,
  UPDATE_REPORT_SELECTION,
  UPDATE_REPORT_SELECTION_ERROR,
  UPDATE_REPORT_SELECTION_SUCCESS,
} from 'containers/Reports/constants'
import {
  SAVE_REPORT,
  SAVE_REPORT_SELECTION_ERROR,
  SAVE_REPORT_SELECTION_SUCCESS,
  GET_REPORT_PROGRESS_PREVIEW_SUCCESS,
  GET_REPORT_DATA_PREVIEW_SUCCESS,
  GET_REPORT_DATA_PREVIEW,
  CLEAR_REPORT_DATA_PREVIEW,
  GET_REPORT_DATA_PREVIEW_ERROR,
  CLEAR_REPORT_DATA_PREVIEW_ERROR,
  REPORT_DATA_PREVIEW_WAITING_FOR_CALCULATION,
} from './constants'
import { waitingForCalculationProgress } from 'utils/actualsCalculationWait'

const initialState = fromJS({
  error: false,
  loading: false,
  reportDataForPreview: undefined,
  reportDataForPreviewError: undefined,
  reportProgressForPreview: undefined,
  previewExchangeRates: undefined,
  previewWaitingForCalculation: undefined,
})

function reportReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_REPORT_SELECTION_ERROR:
    case CREATE_REPORT_SELECTION_ERROR:
    case SAVE_REPORT_SELECTION_ERROR: {
      return state.set('loading', false).set('error', action.error)
    }
    case GET_REPORT_DATA_PREVIEW_ERROR: {
      return state
        .set('loading', false)
        .set('reportDataForPreviewError', action.error)
        .set('previewWaitingForCalculation', undefined)
    }
    case CLEAR_REPORT_DATA_PREVIEW_ERROR: {
      return state.set('reportDataForPreviewError', undefined)
    }
    case CLEAR_REPORT_DATA_PREVIEW: {
      // Also ends any wait still in flight for this preview (see the matching `race` in
      // getReportDataPreview): `loading` is one flat flag shared by every editor in this domain, so
      // leaving it - or a stale progress sentence - set here would block whichever editor opens next.
      return state
        .set('reportDataForPreview', undefined)
        .set('previewExchangeRates', undefined)
        .set('loading', false)
        .set('reportProgressForPreview', undefined)
        .set('previewWaitingForCalculation', undefined)
    }
    case UPDATE_REPORT_SELECTION_SUCCESS:
    case SAVE_REPORT_SELECTION_SUCCESS: {
      // const reportSelectionForState = new ReportRecord(action.reportSelection);
      const returnValue = state
        .set('loading', false)
        .set('reportSelection', undefined)
      return returnValue
    }
    case GET_REPORT_DATA_PREVIEW_SUCCESS:
      return state
        .set('loading', false)
        .set('reportDataForPreview', action.report)
        .set('previewExchangeRates', action.exchangeRates)
        .set('error', false)
        .set('reportProgressForPreview', undefined)
        .set('previewWaitingForCalculation', undefined)
    case GET_REPORT_DATA_PREVIEW:
    case UPDATE_REPORT_SELECTION:
    case SAVE_REPORT:
      // A new read starts: whatever the previous one was waiting for is no longer the live line.
      return state
        .set('loading', action.setLoading)
        .set('error', false)
        .set('reportProgressForPreview', undefined)
        .set('previewWaitingForCalculation', undefined)

    // A reason to show for the wait, whatever `loading` already is. Left untouched here rather than
    // forced true: a silent refresh (getReportDataPreview({ setLoading: false })) must not start
    // showing a spinner just because the calculation it is waiting out also throws up this refusal -
    // see Report/betaVersion.js, which swaps the grid for a LoadingIndicator whenever this domain's
    // `loading` is true. The request is repeated until the calculation releases the company, so this
    // is a stop on the way to data, not an outcome.
    case REPORT_DATA_PREVIEW_WAITING_FOR_CALCULATION:
      return state
        .set('reportDataForPreviewError', undefined)
        .set(
          'reportProgressForPreview',
          waitingForCalculationProgress(action.companies)
        )
        .set('previewWaitingForCalculation', action.companies)
    case GET_REPORT_PROGRESS_PREVIEW_SUCCESS:
      // A progress frame means a read is in flight and the API is narrating the wait itself, so
      // the client's own waiting line has stopped being the live one - see the matching comment in
      // ReportDatas/reducer.js.
      return state
        .set('reportProgressForPreview', action.progress)
        .set('previewWaitingForCalculation', undefined)
    default:
      return state
  }
}

export default reportReducer
